
import { Navbar, Container, Row, Col, Nav, Image } from "react-bootstrap";
import { TestimonialsSlider } from "../testimonials-slider/testimonials-slider";
import feedbackPicture from "./img/feedback.png";
import testimonialsViewCSS from "./css/testimonialsview.css";
import { useTranslation } from 'react-i18next';
export const TestimonialsView = () => {
        const { t } = useTranslation();
 return(
<Container className="wrapper">
        <Row>
            <Col className="wrapper contact-main_container">
<div className="app-container" onclick="hideMenu(); closeSidebar(); closeMenuDownloadLinks()">
                <h1 className="projects-main-heading mb-4">{t("testimonials")}</h1>
                <p className="projects-overview-paragraph">{t("wordOfMouth")}</p>
                <Image className="projects-image" src={feedbackPicture} alt={t("testimonialsImageAlt")} />
                 
                {/* /> */}


                {/* <p className="slider-overview-paragraph center fade-in-up-on-scroll">{t("testimonialsViewTip")}</p> */}

<TestimonialsSlider />
                

               
        </div>
</Col>
</Row>
</Container>
        )
        }